export const SET_REPORT_LIST = 'cost-report/SET_REPORT_LIST';
export const GET_REPORT_LIST = 'cost-report/GET_REPORT_LIST';
export const SET_REPORT_COLUMNS = 'cost-report/SET_REPORT_COLUMNS';

export default {
	SET_REPORT_LIST,
	GET_REPORT_LIST,
	SET_REPORT_COLUMNS,
};
